<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 施設予約状況：閲覧の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>施設予約状況：閲覧の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/reservation-facility-reservation.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          予約施設IDを表示します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 名称
        </div>
        <div class="manual-explain">
          予約施設名称を表示します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 対象環境
        </div>
        <div class="manual-explain">
          本番環境かプレビュー環境を選択します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> カレンダー
        </div>
        <div class="manual-explain">
          カレンダーアイコン押下でカレンダーが表示されます。<br>
          カレンダー上の灰色は休日、黄色は予約数が満席の日を示しています。<br>
          日付を選択すると、予約状況（F枠）が表示されます。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 予約状況
        </div>
        <div class="manual-explain">
          カレンダーで選択した日の予約数を確認することができます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Facility Reservation Status: View
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Reservation Status: View</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation-facility-reservation.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Displays the reservation facility ID.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Name
        </div>
        <div class="manual-explain">
          Displays the name of the reservation facility.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Target Environment
        </div>
        <div class="manual-explain">
          Select either Production environment or Preview environment.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Calendar
        </div>
        <div class="manual-explain">
          Click the calendar icon to display the calendar.<br>
          Gray on the calendar indicates holidays, and yellow indicates days when reservations are fully booked.<br>
          When you select a date, the reservation status (section F) will be displayed.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Reservation Status
        </div>
        <div class="manual-explain">
          You can check the number of reservations for the date selected on the calendar.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
